import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import org.catharsis.TVTally.MyApp
import org.catharsis.spendtel.AppInitializer
import org.catharsis.spendtel.di.iniKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    AppInitializer.onApplicationStart()
    iniKoin()
    ComposeViewport {
        MyApp()
    }
}
